import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, light = false }) => (
  <p className={`flex items-center gap-3 text-xs font-mono uppercase tracking-[0.3em] font-medium ${light ? "text-sky" : "text-cherry"}`}>
    <span className={`inline-block h-px w-8 ${light ? "bg-sky" : "bg-cherry"}`} />
    {children}
  </p>
);
